/**
 * Button to take the user on the smoothest of smooth journeys to the top of the
 * page with just a click :) Only appears when scrolling up (fades out as user scrolls up).
 */
const ToTopButton = (function () {
  // DOM elements
  const toTopBtn = document.querySelector('.js-to-top-btn')

  // Settings
  const scrollThreshold = 50
  let previousScrollYPosition = window.scrollY

  const initToTopButton = () => {
    if (toTopBtn) {
      window.addEventListener('scroll', handleScroll)
      toTopBtn.addEventListener('click', handleClick)
    }
  }

  /**
   * Scroll user to top of the page
   */
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    toTopBtn.blur()
  }

  /**
   * Show to top button (via adding CSS class) only when user scrolls up
   * and is further down the page than one viewport height.
   */
  const handleScroll = () => {
    const currentScrollYPosition = window.scrollY

    if (hasScrolledMoreThanThreshold(currentScrollYPosition)) {
      const scrollDirection = isScrollingDown(currentScrollYPosition) ? 'down' : 'up'
      const hasScrolledPastTheFold = currentScrollYPosition > window.innerHeight
      if (scrollDirection === 'up' && hasScrolledPastTheFold) {
        toTopBtn.classList.add('c-to-top-btn--visible')
      } else {
        toTopBtn.classList.remove('c-to-top-btn--visible')
      }
      previousScrollYPosition = currentScrollYPosition
    }
  }

  /**
   * Used to throttle scroll effect and avoid jittering in/out with small scroll movements
   * @param {number} currentScrollYPosition
   * @returns {number}
   */
  const hasScrolledMoreThanThreshold = (currentScrollYPosition) => {
    return Math.abs(currentScrollYPosition - previousScrollYPosition) > scrollThreshold
  }

  /**
   * Determine current direction of user scrolling
   * @param {number} currentScrollYPosition
   * @returns {boolean}
   */
  const isScrollingDown = (currentScrollYPosition) => {
    return (
      currentScrollYPosition > previousScrollYPosition &&
      !(previousScrollYPosition > 0 && currentScrollYPosition === 0) &&
      !(currentScrollYPosition > 0 && previousScrollYPosition === 0)
    )
  }

  return {
    init: () => {
      setTimeout(() => {
        initToTopButton()
      }, 1000)
    },
  }
})()

export default ToTopButton
